var GraphicSetter = require('./abstract/graphic');
var LogoCreator = require('../creators/logo');
var StickerSetter = require('./sticker');
var StickerGetter = require('../getters/sticker');
var ImagesFactory = require('../../../factory/images');

module.exports = LogoSetter;

function LogoSetter () {
  this.handledAttributes = _.union([
    'shapes',
    'thumb_src',
    'is_vector',
    'fill'
  ], this.handledAttributes);

  this.supportedSubElements = ['image', 'ellipse', 'line', 'rect', 'text', 'polygon', 'circle', 'ellipse', 'path', 'g'];
}

// TODO: simplify by moving most of the stuff to GraphicSetter or inherit from sticker
LogoSetter.prototype = new GraphicSetter();
LogoSetter.prototype.constructor = LogoSetter;
LogoSetter.prototype.updateIsVector = $.noop;

LogoSetter.prototype.updateThumbSrc = function (element, data) {
  var image = $(element).is('image')
    ? element : $(element).children('image')[0];

  if (!image) {
    var permissions = INKIVE.RestrictionsFacade.getAllElementPermissions(element.id);
    var requiresReselect = !permissions || !permissions[0] || !permissions[0].source;
    var isSameImage = false;
    var bbox = svgedit.utilities.getBBox(element);

    if (data.size) {
      bbox.height = data.size.height;
      bbox.width = data.size.width;
    }
    image = this._appendImageLogo(element, _.extend(
      svgedit.utilities.getBBox(element),
      { url: data['thumb_src'] }
    ));

    requiresReselect && this.canvas.removeFromSelection([element]);
  } else {
    var original = ImagesFactory.getOriginalUrl(image.getAttribute('xlink:href'));
    var thumb = ImagesFactory.getOriginalUrl(data['thumb_src']);
    isSameImage = original === thumb;
  }

  var useSmartResize = typeof data['smart_load'] === 'undefined'
    ? true : data['smart_load'];

  thumb = (data['is_vector'] || !useSmartResize) ? data['thumb_src']
    : ImagesFactory.getVersionUrl(data['thumb_src'], 'thumb');

  if (!isSameImage) {
    var selectorManager = svgedit.select.getSelectorManager();
    var selector = selectorManager.requestSelector(element);

    $(element).children(':not(image)').remove();
    selector && selector.updateGripCursors();

    var setThumbnail = function (src) {
      svgedit.utilities.assignAttributes(image, {
        opacity: 1,
        'xlink:href': src
      }, 100);
    };

    var img = new Image();
    img.onload = _.partial(setThumbnail, thumb);
    img.onerror = _.partial(setThumbnail, data['thumb_src']);
    img.src = thumb;

    if (data['is_vector']) {
      data['content'] || this.fetchContent(element, data);
      data['content'] && this.updateContent(element, data);
    } else {
      useSmartResize && this._smartImageLoad(element, data);
      useSmartResize || this.trigger('resolution_optimized', element.getAttribute('id'));
      useSmartResize || this.trigger('resolution_optimized', $(element).find('image').attr('id'));
    }

    requiresReselect && this.canvas.addToSelection([element]);
    data['is_initial_load'] && selectorManager.releaseAllSelectors();
    this.trigger('thumb_src', element.getAttribute('id'), data);
  }
};

LogoSetter.prototype._appendImageLogo = LogoCreator.prototype._appendImageLogo;
LogoSetter.prototype.defineColorGroups = LogoCreator.prototype.defineColorGroups;
LogoSetter.prototype._smartImageLoad = LogoCreator.prototype._smartImageLoad;
LogoSetter.prototype.updateContent = LogoCreator.prototype.updateContent;
LogoSetter.prototype.fetchContent = LogoCreator.prototype.fetchContent;

LogoSetter.prototype.updateShapes = StickerSetter.prototype.updateShapes;
LogoSetter.prototype.updateFill = StickerSetter.prototype.updateFill;
LogoSetter.prototype.getElements = StickerGetter.prototype.getElements;
LogoSetter.prototype.getElementsWithColor = StickerGetter.prototype.getElementsWithColor;
